import { ActionService } from 'dashboard-services';

import { AuthUtils } from 'utils';

export default (() => {
  
  const ON_CHANGE = 'ON_CHANGE_SETTINGS'
  const onChange = ActionService.makeActionCreator(ON_CHANGE, 'value', 'name')

  const hasTesterAccess = () => (_, getState) => {
    const uiEntitlements = getState().settingsState.uiEntitlements
    return AuthUtils.hasTesterAccess({ uiEntitlements })
  }

  return {
    onChange,
    ON_CHANGE,
    hasTesterAccess
  }
})()